import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { formatApiError } from "../../lib/api";
import { PasswordInput } from "../../components/PasswordInput";
import logoNavy from "../../assets/logo-navy.png";

export default function AdminLogin() {
  const { adminLogin } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await adminLogin(username, password);
      navigate("/admin");
    } catch (err) { setError(formatApiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-navy hero-motif px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-white rounded-2xl p-8 shadow-2xl">
        <div className="text-center mb-6">
          <img src={logoNavy} alt="Begum's Biryani Secret" className="mx-auto h-16 w-auto mb-3" />
          <h1 className="font-serif text-3xl text-navy">Admin Access</h1>
          <p className="text-sm text-muted-foreground mt-1">Begum's Biryani Secrets Control Panel</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div><label className="text-xs font-medium text-muted-foreground">Login ID</label><input value={username} onChange={(e) => setUsername(e.target.value)} required placeholder="Enter admin login ID" data-testid="admin-login-username" className="w-full mt-1 border border-black/15 rounded-lg px-3.5 py-2.5 text-sm outline-none focus:ring-2 focus:ring-gold" /></div>
          <div><label className="text-xs font-medium text-muted-foreground">Password</label><PasswordInput value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="Password" testId="admin-login-password" className="w-full mt-1 border border-black/15 rounded-lg px-3.5 py-2.5 text-sm outline-none focus:ring-2 focus:ring-gold" /></div>
          {error && <div className="text-sm text-destructive" data-testid="admin-login-error">{error}</div>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit" className="w-full bg-navy text-cream font-semibold py-3 rounded-full hover:bg-navy-soft transition-colors disabled:opacity-60">{loading ? "Signing in..." : "Sign In"}</button>
        </form>
      </div>
    </div>
  );
}
